"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var apollo_client_1 = require("apollo-client");
var apollo_link_1 = require("apollo-link");
var observables_1 = require("apollo-client/util/observables");
var observableToPromise_1 = tslib_1.__importDefault(require("apollo-client/util/observableToPromise"));
var apollo_utilities_1 = require("apollo-utilities");
var offline_first_1 = require("@wora/offline-first");
var uuid_1 = require("uuid");
var hasOwnProperty = Object.prototype.hasOwnProperty;
var ApolloClientOffline = (function (_super) {
    tslib_1.__extends(ApolloClientOffline, _super);
    function ApolloClientOffline(apolloOptions, persistOptions) {
        if (persistOptions === void 0) { persistOptions = {}; }
        var _this = _super.call(this, apolloOptions) || this;
        _this.rehydrated = typeof window === 'undefined';
        _this.queryManager.isOnline = function () { return _this.isOnline(); };
        var persistOptionsStoreOffline = tslib_1.__assign({ prefix: 'apollo-offline', serialize: true }, persistOptions);
        _this.apolloStoreOffline = new offline_first_1.OfflineFirst(persistOptionsStoreOffline);
        _this.setOfflineOptions();
        if (_this.rehydrated) {
            _this.promisesRestore = Promise.resolve(true);
        }
        var originalFetchQuery = _this.queryManager.fetchQuery;
        _this.queryManager.fetchQuery = function (queryId, options, fetchType, fetchMoreForQueryId) {
            var oldFetchPolicy = options.fetchPolicy;
            if (!this.isOnline()) {
                options.fetchPolicy = 'cache-only';
            }
            var result = originalFetchQuery.apply(this, [queryId, options, fetchType, fetchMoreForQueryId]);
            options.fetchPolicy = oldFetchPolicy;
            return result;
        };
        return _this;
    }
    ApolloClientOffline.prototype.setOfflineOptions = function (offlineOptions) {
        var _this = this;
        if (offlineOptions === void 0) { offlineOptions = {}; }
        var onComplete = offlineOptions.onComplete, onDiscard = offlineOptions.onDiscard, link = offlineOptions.link, others = tslib_1.__rest(offlineOptions, ["onComplete", "onDiscard", "link"]);
        var options = tslib_1.__assign({ execute: function (offlineRecord) { return _this.executeOfflineMutation(link, offlineRecord); }, onComplete: function (o) { return complete(_this, onComplete, o); }, onDiscard: function (o) { return discard(_this, onDiscard, o); } }, others);
        this.apolloStoreOffline.setOfflineOptions(options);
    };
    ApolloClientOffline.prototype.dispose = function () {
        this.getStoreOffline().dispose();
    };
    ApolloClientOffline.prototype.hydrate = function () {
        var _this = this;
        if (!this.promisesRestore) {
            this.promisesRestore = Promise.all([this.getStoreOffline().hydrate(), this.cache.hydrate()])
                .then(function (_result) {
                _this.cache.broadcastWatches();
                _this.queryManager.broadcastQueries();
                _this.rehydrated = true;
                return true;
            })
                .catch(function (error) {
                _this.rehydrated = false;
                _this.promisesRestore = null;
                throw error;
            });
        }
        return this.promisesRestore;
    };
    ApolloClientOffline.prototype.getStoreOffline = function () {
        return this.apolloStoreOffline;
    };
    ApolloClientOffline.prototype.isRehydrated = function () {
        return this.rehydrated;
    };
    ApolloClientOffline.prototype.isOnline = function () {
        return this.getStoreOffline().isOnline();
    };
    ApolloClientOffline.prototype.watchQuery = function (options) {
        var oldFetchPolicy = options.fetchPolicy;
        if (!this.isOnline()) {
            options.fetchPolicy = 'cache-only';
        }
        var result = _super.prototype.watchQuery.call(this, options);
        result.options.fetchPolicy = oldFetchPolicy;
        return result;
    };
    ApolloClientOffline.prototype.mutateOffline = function (mutationOptions) {
        var _this = this;
        var context = mutationOptions.context, update = mutationOptions.update, fetchPolicy = mutationOptions.fetchPolicy, variables = mutationOptions.variables, mutation = mutationOptions.mutation, updateQueriesByName = mutationOptions.updateQueries;
        var generateUpdateQueriesInfo = function () {
            var ret = {};
            if (updateQueriesByName) {
                _this.queries.forEach(function (_a, queryId) {
                    var observableQuery = _a.observableQuery;
                    if (observableQuery) {
                        var queryName = observableQuery.queryName;
                        if (queryName && hasOwnProperty.call(updateQueriesByName, queryName)) {
                            ret[queryId] = {
                                updater: updateQueriesByName[queryName],
                                query: _this.queryStore.get(queryId),
                            };
                        }
                    }
                });
            }
            return ret;
        };
        var optimisticResponse = typeof mutationOptions.optimisticResponse === 'function'
            ? mutationOptions.optimisticResponse(variables)
            : mutationOptions.optimisticResponse;
        var result = { data: optimisticResponse };
        var id = uuid_1.v4();
        if (fetchPolicy !== 'no-cache' && optimisticResponse) {
            this.store.markMutationInit({
                variables: variables,
                updateQueries: generateUpdateQueriesInfo(),
                update: update,
                optimisticResponse: optimisticResponse,
                document: mutation,
                mutationId: id,
            });
            this.queryManager.broadcastQueries();
        }
        var payload = {
            mutation: mutation,
            variables: variables,
            context: context,
            optimisticResponse: optimisticResponse,
        };
        var sink = this.cache.optimisticData.data;
        var backup = {};
        var state = this.cache.data.getState();
        Object.keys(sink).forEach(function (key) { return (backup[key] = state[key]); });
        var request = {
            payload: payload,
            backup: backup,
            sink: sink,
        };
        return this.getStoreOffline()
            .publish({ id: id, request: request, serial: true })
            .then(function (offlineRecord) {
            if (fetchPolicy !== 'no-cache' && optimisticResponse) {
                _this.store.markMutationResult({
                    result: result,
                    variables: variables,
                    updateQueries: generateUpdateQueriesInfo(),
                    update: update,
                    mutationId: offlineRecord.id,
                    document: mutation,
                });
                _this.store.markMutationComplete({
                    mutationId: id,
                    optimisticResponse: optimisticResponse,
                });
                _this.queryManager.broadcastQueries();
            }
            return result;
        })
            .catch(function (error) {
            _this.store.markMutationComplete({
                mutationId: id,
                optimisticResponse: optimisticResponse,
            });
            _this.queryManager.broadcastQueries();
            throw error;
        });
    };
    ApolloClientOffline.prototype.mutate = function (options) {
        if (!this.isOnline()) {
            return this.mutateOffline(options);
        }
        return _super.prototype.mutate.call(this, options);
    };
    ApolloClientOffline.prototype.executeOfflineMutation = function (link, offlineRecord) {
        if (link === void 0) { link = this.link; }
        var _a = offlineRecord.request.payload, mutation = _a.mutation, variables = _a.variables, context = _a.context;
        var query = this.queryManager.transform(mutation).document;
        var operation = {
            query: query,
            variables: variables,
            operationName: apollo_utilities_1.getOperationName(query) || void 0,
            context: this.queryManager.prepareContext(tslib_1.__assign(tslib_1.__assign({}, context), { forceFetch: true })),
        };
        var options = {
            observable: observables_1.multiplex(apollo_link_1.execute(link, operation)),
        };
        return observableToPromise_1.default(options, function (result) { return result; });
    };
    return ApolloClientOffline;
}(apollo_client_1.ApolloClient));
exports.ApolloClientOffline = ApolloClientOffline;
function complete(client, onComplete, options) {
    if (onComplete === void 0) { onComplete = function (_o) { return Promise.resolve(true); }; }
    var offlineRecord = options.offlineRecord, response = options.response;
    var id = offlineRecord.id;
    return onComplete({
        id: id,
        offlinePayload: offlineRecord,
        response: response[0],
    });
}
function discard(client, onDiscard, options) {
    if (onDiscard === void 0) { onDiscard = function (_o) { return Promise.resolve(true); }; }
    var offlineRecord = options.offlineRecord, error = options.error;
    var id = offlineRecord.id;
    return onDiscard({ id: id, error: error, offlinePayload: offlineRecord });
}
//# sourceMappingURL=ApolloClientOffline.js.map